import classNames from 'classnames';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import { useCtx } from '..';
import { DropdownContext } from './DropdownContext';
import { MenuContext } from './MenuContext';
import { OptionAction } from './OptionAction';
import s from './styles.module.css.json';
export var Option = function (_a) {
    var _b;
    var onClick = _a.onClick, to = _a.to, active = _a.active, red = _a.red, valid = _a.valid, invalid = _a.invalid, children = _a.children, disabled = _a.disabled, closeMenuOnClick = _a.closeMenuOnClick;
    var ctx = useCtx();
    var id = useMemo(function () { return new Date().getTime().toString(36); }, []);
    var _c = useContext(MenuContext), searchTerm = _c.searchTerm, addOption = _c.addOption, setClickHandlerForOption = _c.setClickHandlerForOption;
    var childrenArray = React.Children.toArray(children);
    var buttons = childrenArray.filter(function (child) {
        return typeof child === 'object' &&
            'type' in child &&
            child.type === OptionAction;
    });
    var notButtons = childrenArray.filter(function (child) {
        return typeof child !== 'object' ||
            !('type' in child) ||
            child.type !== OptionAction;
    });
    var contentRef = useRef(null);
    var _d = useState(''), innerText = _d[0], setInnerText = _d[1];
    useEffect(function () {
        if (contentRef.current) {
            setInnerText(contentRef.current.innerText);
        }
    });
    var closeMenu = useContext(DropdownContext).closeMenu;
    var handleClick = useCallback(function (e) {
        if (!onClick && !to) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (closeMenuOnClick !== null && closeMenuOnClick !== void 0 ? closeMenuOnClick : true) {
            closeMenu();
        }
        if (to) {
            ctx === null || ctx === void 0 ? void 0 : ctx.navigateTo(to);
        }
        if (onClick) {
            onClick(e);
        }
    }, [closeMenuOnClick, closeMenu, onClick, to]);
    useEffect(function () {
        return addOption(id);
    }, [id]);
    useEffect(function () {
        return setClickHandlerForOption(id, handleClick);
    }, [id, handleClick, setClickHandlerForOption]);
    if (innerText &&
        searchTerm &&
        !innerText.toLowerCase().includes(searchTerm.toLowerCase())) {
        return null;
    }
    var content = (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: s.Dropdown__menu__option__content, ref: contentRef, onClick: handleClick }, notButtons),
        buttons.length > 0 && (React.createElement("div", { className: s.Dropdown__menu__option__icons }, buttons))));
    return (React.createElement("div", { className: classNames(s.Dropdown__menu__option, (_b = {},
            _b[s['Dropdown__menu__option--is-active']] = active,
            _b[s['Dropdown__menu__option--is-disabled']] = disabled,
            _b[s['Dropdown__menu__option--is-valid']] = valid,
            _b[s['Dropdown__menu__option--is-invalid']] = invalid,
            _b[s['Dropdown__menu__option--is-dangerous']] = red,
            _b)), "data-option-id": id }, content));
};
//# sourceMappingURL=Option.js.map